import { useBroadcastStorage } from './useBroadcastStorage';
import { EntityTypeEnum } from '../../gql/typings';
import { defaultPageNumber } from '../components/Table/utils';

const generateTablePageKey = (entityType: EntityTypeEnum) => `${entityType}-table-page`;

export const usePageState = (
  entityType: EntityTypeEnum
) => useBroadcastStorage<number>(generateTablePageKey(entityType), defaultPageNumber);
